import { render, staticRenderFns } from "./BannerPage.vue?vue&type=template&id=443dcb78&scoped=true&"
import script from "./BannerPage.vue?vue&type=script&lang=js&"
export * from "./BannerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443dcb78",
  null
  
)

export default component.exports